import { takeLatest, put, call } from 'redux-saga/effects';
import * as correspondentBillingAction from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_CONTENT_TYPE_FILE, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';

export function* getPaginatedBillingList(action) {
    let requestUrl = `${CORE_API}/correspondent/billing/filter/${action.data.pageNo}/${action.data.pageSize}`;
    try {
        const listResult = yield call(request, requestUrl, { data: action.data.request, method: 'POST', headers: HTTP_HEADERS });
        yield put(correspondentBillingAction.viewPageSuccess(listResult.data));
    } catch (err) {

        yield put(correspondentBillingAction.viewPageSuccess(err))
    }
}
export function* fetchPaginatedBillingList() {

    yield takeLatest(correspondentBillingAction.VIEW_BILLING_PAGES, getPaginatedBillingList);
}

export function* downloadBillingDetails(action) {
    let requestUrl = `${CORE_API}/correspondent/billing/download`;
    try {
        const listResult = yield call(request, requestUrl, {
            data: action.data, method: 'POST', headers: HTTP_HEADERS_CONTENT_TYPE_FILE, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER
        });
        yield put(correspondentBillingAction.downloadBillingDetailsSuccess(listResult.data));
    } catch (err) {

        yield put(correspondentBillingAction.downloadBillingDetailsFailure(err))
    }
}
export function* downloadBillingDetailsExcel() {

    yield takeLatest(correspondentBillingAction.DOWNLOAD_BILLING_DETAILS_EXCEL, downloadBillingDetails);
}

export function* getCorrespondentList(action) {
    let requestUrl = `${CORE_API}/correspondent/filter/entities`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(correspondentBillingAction.fetchCorrespondentListBillingSuccess(listResult.data));
    } catch (err) {

        yield put(correspondentBillingAction.fetchCorrespondentListBillingFailure(err))
    }
}
export function* fetchCorrespondentListBilling() {

    yield takeLatest(correspondentBillingAction.FETCH_CORRESPONDENT_LIST_BILLING, getCorrespondentList);
}